module.exports = __webpack_public_path__ + "static/media/image_13.e53c9272.gif";